import { createAsyncThunk } from '@reduxjs/toolkit';
import { KidParams, KidListParams, KidListResponse } from './types';
import jwtAxios from "@nxsys/services/axios";

// 1. Calculate KID value
export const calcKPayeeValue = createAsyncThunk(
  'kid/calcKPayeeValue',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/calculatePayeeValue', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const calcKUmbrellaValue = createAsyncThunk(
  'kid/calcKUmbrellaValue',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/calculateUmbrellaValue', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// preview email
export const previewForCis = createAsyncThunk<{ data: string }, KidParams>(
  'kid/previewForCis',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/preview', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const previewForPaye = createAsyncThunk<{ data: string }, KidParams>(
  'kid/previewForPaye',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/paye/preview', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const previewForUmbrella = createAsyncThunk<{ data: string }, KidParams>(
  'kid/previewForUmbrella',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/umbrella/preview', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Send email
export const sendEmailForCis = createAsyncThunk<{ success: boolean }, KidParams>(
  'kid/sendEmailForCis',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendEmailForPaye = createAsyncThunk<{ success: boolean }, KidParams>(
  'kid/sendEmailForPaye',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/paye', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendEmailForUmbrella = createAsyncThunk<{ success: boolean }, KidParams>(
  'kid/sendEmailForUmbrella',
  async (payload: KidParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post('kid/umbrella', payload);
      return {...payload,...response.data};
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 2. Get KID history
export const getKidHistory = createAsyncThunk<KidListResponse, KidListParams>(
  'kid/getKidHistory',
  async (params: KidListParams, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get('kid/emails',{
        params,
      });
      return {
        data: response.data.data,
        pagination: {
          current: params.page || 0,
          pageSize: params.size || 20,
          totalDocs: response.data.totalDocs,
        },
        queryParams: params,
      };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const resendEmail = createAsyncThunk<
  { success: boolean },
  { emailLogId: string }
>(
  'kid/resendEmail',
  async (payload: { emailLogId: string }, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.post(`kid/emails/${payload.emailLogId}/resend`);
      return { ...payload, ...response.data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export default {
    calcKPayeeValue,
    calcKUmbrellaValue,
    previewForCis,
    previewForPaye,
    previewForUmbrella,
    sendEmailForCis,
    sendEmailForPaye,
    sendEmailForUmbrella,
    getKidHistory,
    resendEmail
}